import { css } from "lit";

const GAP = 4;

export const style = css`
	:host {
		padding: 0;
		display: block;
		margin-right: -20px;
	}

	.body {
		display: flex;
		gap: ${GAP}px;
		flex-wrap: wrap;
		padding: ${GAP}px;
		padding-right: ${GAP + 10}px;
	}

	.head {
		padding-right: 10px;
		border-bottom: 1px solid var(--og-bucket-border-color);
	}

	.head-inner {
		flex: 0;
		display: flex;
		flex-direction: row;
	}

	.head-inner > * {
		flex: 1;
		text-align: center;
		border-right: 1px solid var(--og-bucket-border-color);
		height: 100%;
	}

	.head-inner > *:last-child {
		border-right: none;
	}

	.item {
		border: 1px solid #6D6D6D;
		background-color: var(--og-colortype-gray-background-color-soft-40);
		border-radius: var(--og-base-radius);
		color: var(--og-text-color-3);
		cursor: pointer;
	}

	.item .og-icon {
		color: #C8C8C8;
	}

	.item og-button {
		flex: 0 0 20px;
	}

	.item-default {
		flex: 0;
		min-width: 39px;
		height: 39px;
		position: relative;
		text-align: center;
		padding-top: 5px;
	}

	.item-default .item-name-wrapper {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		text-align: center;
		font-size: 8px;
		white-space: nowrap;
		overflow: hidden;
		padding: 0 2px 2px;
		text-overflow: ellipsis;
		max-width: 100%;
	}

	.item-default .item-name {
		display: inline-block;
		white-space: nowrap;
		transition: transform 0.3s;
	}

	.item-custom .item-name-wrapper {
		overflow: hidden;
		flex: 1;
	}

	.item-custom .item-name {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	.item-default.long-name:hover .item-name-wrapper .item-name {
		animation: label-scroll 2s linear 0.4s 1;
	}

	@keyframes label-scroll {
		0%   { transform: translateX(0); }
		10%  { transform: translateX(0); }
		90%  { transform: translateX(var(--shift)); }
		100% { transform: translateX(var(--shift)); }
	}

	.item-custom {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 5px;
		min-width: 100%;
		height: 22px;
	}

	.item:hover, .item.active {
		border: 1px solid var(--og-colortype-accent-border-color);
		background-color: var(--og-accent-color-alpha-30);
		border-radius: var(--og-base-radius);
		color: var(--og-text-color-3);
	}
`;
